import { NewsletterContentModule } from '@silvertours/common-landingpages-view';
import { NewsletterRegistrationLegacy } from '@silvertours/front-features';

export const NewsletterModule = ({
  badge: { text: badgeText } = { text: '' },
  heading: { text: title } = { text: '' },
  cashbackBadgeText,
  cashbackTooltipText,
  image,
  features: usps = [],
}: NewsletterContentModule) => (
  <div id="newsletter">
    <NewsletterRegistrationLegacy.NewsletterRegistration
      type="index"
      badgeText={badgeText}
      heading={title}
      cashbackBadgeText={cashbackBadgeText}
      cashbackTooltipText={cashbackTooltipText}
      image={image}
      usps={usps}
    />
  </div>
);
